"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.textAndImageSectionPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _svg = _interopRequireDefault(require("../svg"));

var _markdown = _interopRequireDefault(require("../markdown"));

var _image = _interopRequireDefault(require("./image"));

var _util = require("./util");

var _commonPropTypes = _interopRequireDefault(require("../common-prop-types"));

var _textAndImageSection = _interopRequireDefault(require("../text-and-image-section"));

require("./text-and-image-section.less");

var _sections = require("./sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DISPLAY_CLASSES = ['Left Image Card', 'Right Image Card', 'Top Image Card', 'Bottom Image Card'];
var PAGE_WIDTH = 800;
var SIDE_IMAGE_WIDTHS = {
  small: Math.round(PAGE_WIDTH / 4),
  medium: Math.round(PAGE_WIDTH / 3),
  large: Math.round(PAGE_WIDTH / 2),
  huge: Math.round(PAGE_WIDTH * 0.75),
  original: null
};
var VERTICAL_IMAGE_WIDTHS = {
  small: Math.round(PAGE_WIDTH / 2),
  medium: Math.round(PAGE_WIDTH * 0.75),
  large: Math.round(PAGE_WIDTH),
  huge: Math.round(PAGE_WIDTH),
  original: null
};
var IMAGE_PROPORTION_TO_PERCENT = {
  small: '33%',
  medium: '50%',
  large: '66%',
  original: '66%',
  huge: '75%'
};

var TextAndImageSection = function TextAndImageSection(_ref) {
  var callToActionButton = _ref.callToActionButton,
      ctaPosition = _ref.ctaPosition,
      className = _ref.className,
      displayType = _ref.displayType,
      headerClass = _ref.headerClass,
      headerLocation = _ref.headerLocation,
      icons = _ref.icons,
      imageIndex = _ref.imageIndex,
      imageProportionText = _ref.imageProportion,
      images = _ref.images,
      imageWidth = _ref.imageWidth,
      stringSubstitutions = _ref.stringSubstitutions,
      subTitleText = _ref.subTitle,
      text = _ref.text,
      titleText = _ref.title,
      v2 = _ref.v2,
      variant = _ref.variant,
      wistiaVideo = _ref.wistiaVideo;
  var subbedTitleText = titleText && (0, _util.stringSubstitution)(titleText, stringSubstitutions);

  var title = subbedTitleText && /*#__PURE__*/_react["default"].createElement("h2", {
    className: headerClass
  }, subbedTitleText);

  var subbedSubTitleText = subTitleText && (0, _util.stringSubstitution)(subTitleText, stringSubstitutions);

  var subTitle = subTitleText && /*#__PURE__*/_react["default"].createElement("h3", {
    className: "subTitle h3"
  }, subbedSubTitleText);

  var icon = icons && /*#__PURE__*/_react["default"].createElement(_svg["default"], _extends({
    className: "imageSection"
  }, icons[0].fields));

  var displayClass = _lodash["default"].includes(DISPLAY_CLASSES, displayType) ? _lodash["default"].camelCase(displayType) : 'leftImageCard';
  var ctaButton = callToActionButton && (0, _sections.getWidget)(callToActionButton);

  var headerLocationClass = _lodash["default"].camelCase(headerLocation);

  var header = /*#__PURE__*/_react["default"].createElement("div", {
    className: "header ".concat(headerLocationClass)
  }, title, subTitle);

  var hasInlineHeader = headerLocation === 'Inline';

  var imageProportion = _lodash["default"].toLower(imageProportionText);

  var maxImageWidth;

  if (_lodash["default"].includes(['leftImageCard', 'rightImageCard'], displayClass)) {
    maxImageWidth = SIDE_IMAGE_WIDTHS[imageProportion];
  } else if (_lodash["default"].includes(['topImageCard', 'bottomImageCard'], displayClass)) {
    maxImageWidth = VERTICAL_IMAGE_WIDTHS[imageProportion];
  } // TODO: Responsive Images? https://css-tricks.com/responsive-images-youre-just-changing-resolutions-use-srcset/
  // Responsive images are the responsibility of the implementor, pass in a responsive image


  var image = images && images[imageIndex] ? /*#__PURE__*/_react["default"].createElement(_image["default"], {
    media: images[imageIndex],
    className: "imageSection ".concat(imageProportion),
    width: maxImageWidth
  }) : null;

  var bodyContent = text && /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "paragraph",
    source: (0, _util.stringSubstitution)(text, stringSubstitutions)
  });

  if (v2) {
    image = image && _lodash["default"].get(images, "[".concat(imageIndex, "].fields.file.url")); // Get correct imageWidth for v2

    var v2ImageWidth;

    if (imageWidth) {
      v2ImageWidth = imageWidth;
    } else if (imageProportion) {
      v2ImageWidth = IMAGE_PROPORTION_TO_PERCENT[imageProportion];
    }

    var wistiaButton = wistiaVideo && (0, _sections.getWidget)(wistiaVideo);
    return /*#__PURE__*/_react["default"].createElement(_textAndImageSection["default"], {
      className: className,
      ctaButton: ctaButton,
      ctaPosition: ctaPosition,
      displayType: displayClass,
      headerClass: headerClass,
      headerLocation: headerLocationClass,
      icon: icon,
      image: image,
      imageProportion: imageProportion,
      subTitle: subbedSubTitleText,
      bodyContent: bodyContent,
      title: subbedTitleText,
      wistiaButton: wistiaButton,
      imageWidth: v2ImageWidth
    });
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('TextAndImageSection', className, displayClass, variant)
  }, hasInlineHeader || header, /*#__PURE__*/_react["default"].createElement("div", {
    className: "section-body ".concat(displayClass)
  }, image, icon, /*#__PURE__*/_react["default"].createElement("div", {
    className: "textSection"
  }, hasInlineHeader && header, bodyContent, ctaButton)));
};

var textAndImageSectionPropTypes = {
  callToActionButton: _propTypes["default"].shape({
    fields: _propTypes["default"].shape({})
  }),
  ctaPosition: _propTypes["default"].string,
  className: _propTypes["default"].string,
  displayType: _propTypes["default"].string,
  headerClass: _propTypes["default"].string,
  headerLocation: _propTypes["default"].oneOf(['Inline', 'Top Center', 'Top Left']),
  icons: _propTypes["default"].arrayOf(_propTypes["default"].object),
  imageIndex: _propTypes["default"].number,
  imageProportion: _propTypes["default"].oneOf(['Small', 'Medium', 'Large', 'Huge', 'Original']),
  images: _propTypes["default"].arrayOf(_propTypes["default"].object),
  imageWidth: _propTypes["default"].string,
  stringSubstitutions: _commonPropTypes["default"].stringSubstitutions,
  subTitle: _propTypes["default"].string,
  text: _propTypes["default"].string,
  title: _propTypes["default"].string,
  v2: _propTypes["default"].bool,
  variant: _propTypes["default"].oneOf(['default', 'contained', 'containedBrand', 'slide']),
  wistiaVideo: _propTypes["default"].shape({
    fields: _propTypes["default"].shape({})
  })
};
exports.textAndImageSectionPropTypes = textAndImageSectionPropTypes;
TextAndImageSection.propTypes = textAndImageSectionPropTypes;
TextAndImageSection.defaultProps = {
  callToActionButton: null,
  ctaPosition: null,
  className: '',
  displayType: null,
  headerClass: 'h2',
  headerLocation: 'Inline',
  icons: null,
  imageIndex: 0,
  imageProportion: 'Small',
  images: null,
  imageWidth: null,
  stringSubstitutions: {},
  subTitle: null,
  text: null,
  title: null,
  v2: false,
  variant: 'default',
  wistiaVideo: null
};
(0, _sections.registerWidget)('textAndImageSection', TextAndImageSection);
var _default = TextAndImageSection;
exports["default"] = _default;